module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('h5', {
    staticClass: "page-title mb-2"
  }, [_c('b', [_vm._v(" " + _vm._s(_vm.$route.name) + " ")])])]), _vm._v(" "), _c('b-navbar-nav', [_c('b-nav-form', [_c('b-button-group', {
    staticClass: "m2-1 text-right mb-1",
    attrs: {
      "size": "sm"
    }
  }, [_c('b-button', {
    attrs: {
      "size": "xxl",
      "variant": "light"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n              ")], 1)], 1), _vm._v(" "), _c('Filter-Agency-Modal'), _vm._v(" "), _c('FilterCBModal'), _vm._v(" "), _c('b-button', {
    class: 'ml-4' + _vm.visible ? null : 'collapsed',
    staticStyle: {
      "font-size": "0.675rem",
      "margin-left": "5px"
    },
    attrs: {
      "size": "sm",
      "variant": _vm.Filter.commonFilter ||
        _vm.Filter.userFilter ||
        _vm.Filter.enqStatusFilter ||
        _vm.Filter.represntativeFilter ||
        _vm.Filter.salePerFilter ||
        _vm.Filter.clientFilter ||
        _vm.Filter.slineFilter ||
        _vm.Filter.branchFilter ||
        _vm.Filter.porFilter ||
        _vm.Filter.polFilter ||
        _vm.Filter.fpodFilter ||
        _vm.Filter.fclFilter ||
        _vm.Filter.incotermFilter ||
        _vm.Filter.enqNoFilter ||
        _vm.Filter.transTypeFilter ||
        _vm.Filter.enqDateFilter ||
        _vm.Filter.saleDateFilter ||
        _vm.Filter.dateRange.startDate ||
        _vm.Filter.dateRange.endDate ?
        'outline-danger' :
        'outline-primary',
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v(_vm._s(_vm.Filter.commonFilter ||
    _vm.Filter.userFilter ||
    _vm.Filter.enqStatusFilter ||
    _vm.Filter.represntativeFilter ||
    _vm.Filter.salePerFilter ||
    _vm.Filter.clientFilter ||
    _vm.Filter.slineFilter ||
    _vm.Filter.branchFilter ||
    _vm.Filter.porFilter ||
    _vm.Filter.polFilter ||
    _vm.Filter.fpodFilter ||
    _vm.Filter.fclFilter ||
    _vm.Filter.incotermFilter ||
    _vm.Filter.enqNoFilter ||
    _vm.Filter.transTypeFilter ||
    _vm.Filter.enqDateFilter ||
    _vm.Filter.saleDateFilter ||
    _vm.Filter.dateRange.startDate ||
    _vm.Filter.dateRange.endDate ?
    "Filter ON" :
    "Filter OFF"))]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.goToBookingREquest(null, 2)
      }
    }
  }, [_vm._v("Booking Request")])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.visible) ? _c('div', [_c('b-card', {
    attrs: {
      "mt-1": ""
    }
  }, [_c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale,
      "disabled": _vm.Filter.DFlag ? true : false
    },
    on: {
      "update": _vm.getFreightEnquiryPriceingList
    },
    model: {
      value: (_vm.Filter.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "dateRange", $$v)
      },
      expression: "Filter.dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Enq Date")]), _c('b-form-input', {
    attrs: {
      "type": "date",
      "id": "enqDateFilter-datepicker",
      "placeholder": "YYYY-MM-DD",
      "autocomplete": "off"
    },
    on: {
      "input": _vm.getFreightEnquiryPriceingList
    },
    model: {
      value: (_vm.Filter.enqDateFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "enqDateFilter", $$v)
      },
      expression: "Filter.enqDateFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("SOB Date")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "date",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Select SOB Date",
      "id": "saleDateFilter",
      "name": "saleDateFilter",
      "autocomplete": "off"
    },
    on: {
      "input": _vm.getFreightEnquiryPriceingList
    },
    model: {
      value: (_vm.Filter.saleDateFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "saleDateFilter", $$v)
      },
      expression: "Filter.saleDateFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Incoterm")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.deliveryTermsName,
      "option-value": "deliveryTermsVal",
      "option-text": "deliveryTermsText",
      "placeholder": "Select Incoterm"
    },
    on: {
      "input": _vm.getFreightEnquiryPriceingList
    },
    model: {
      value: (_vm.Filter.incotermFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "incotermFilter", $$v)
      },
      expression: "Filter.incotermFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.filterStatusList,
      "option-value": "StatusVal",
      "option-text": "StatusText",
      "placeholder": "Select Status"
    },
    on: {
      "input": _vm.getFreightEnquiryPriceingList
    },
    model: {
      value: (_vm.Filter.enqStatusFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "enqStatusFilter", $$v)
      },
      expression: "Filter.enqStatusFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Representative")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Representative"
    },
    on: {
      "input": _vm.getFreightEnquiryPriceingList
    },
    model: {
      value: (_vm.Filter.represntativeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "represntativeFilter", $$v)
      },
      expression: "Filter.represntativeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Sales Person")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Sales Person"
    },
    on: {
      "input": _vm.getFreightEnquiryPriceingList
    },
    model: {
      value: (_vm.Filter.salePerFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "salePerFilter", $$v)
      },
      expression: "Filter.salePerFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Transport Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.TransportTypeList,
      "option-value": "StatusVal",
      "option-text": "StatusText",
      "placeholder": "Select Export / Import"
    },
    on: {
      "input": _vm.getFreightEnquiryPriceingList
    },
    model: {
      value: (_vm.Filter.transTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "transTypeFilter", $$v)
      },
      expression: "Filter.transTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Branch")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllBranchList'],
      "id": "branchfilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All",
      "isDisabled": _vm.$sessionsStorage.get('designation') != 'Admin' ? true : false
    },
    on: {
      "input": _vm.getFreightEnquiryPriceingList
    },
    model: {
      value: (_vm.Filter.branchFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "branchFilter", $$v)
      },
      expression: "Filter.branchFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Client")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "id": "clientfilter",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Client Name"
    },
    on: {
      "input": _vm.getFreightEnquiryPriceingList
    },
    model: {
      value: (_vm.Filter.clientFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "clientFilter", $$v)
      },
      expression: "Filter.clientFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Shipping Line")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllShippingLineList'],
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line",
      "isDisabled": _vm.$sessionsStorage.get('designation') != 'Admin' ? true : false
    },
    on: {
      "input": _vm.getFreightEnquiryPriceingList
    },
    model: {
      value: (_vm.Filter.slineFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "slineFilter", $$v)
      },
      expression: "Filter.slineFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POR")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.Filter.transTypeFilter == 'EXPORT' ?
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEnginePORDDList'
        ] :
        _vm.Filter.transTypeFilter == 'IMPORT' ?
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPORDDList'
        ] :
        _vm.Filter.transTypeFilter == 'CRC' ?
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
        ] :
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEnginePORDDList'
        ],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select POR"
    },
    on: {
      "input": _vm.getFreightEnquiryPriceingList
    },
    model: {
      value: (_vm.Filter.porFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "porFilter", $$v)
      },
      expression: "Filter.porFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POL")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.Filter.transTypeFilter == 'EXPORT' ?
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEnginePOLDDList'
        ] :
        _vm.Filter.transTypeFilter == 'IMPORT' ?
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPOLDDList'
        ] :
        _vm.Filter.transTypeFilter == 'CRC' ?
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
        ] :
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEnginePOLDDList'
        ],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select POL"
    },
    on: {
      "input": _vm.getFreightEnquiryPriceingList
    },
    model: {
      value: (_vm.Filter.polFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "polFilter", $$v)
      },
      expression: "Filter.polFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("FPOD")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.Filter.transTypeFilter == 'EXPORT' ?
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineFPODDDList'
        ] :
        _vm.Filter.transTypeFilter == 'IMPORT' ?
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineIMPFPODDDList'
        ] :
        _vm.Filter.transTypeFilter == 'CRC' ?
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
        ] :
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineFPODDDList'
        ],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Final Port of Discharge"
    },
    on: {
      "input": _vm.getFreightEnquiryPriceingList
    },
    model: {
      value: (_vm.Filter.fpodFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "fpodFilter", $$v)
      },
      expression: "Filter.fpodFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Container Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllContainerTypeList'],
      "option-value": "containerTypeId",
      "option-text": "containerType",
      "placeholder": "Select Container Type"
    },
    on: {
      "input": _vm.getFreightEnquiryPriceingList
    },
    model: {
      value: (_vm.Filter.containerTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "containerTypeFilter", $$v)
      },
      expression: "Filter.containerTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("FCL/LCL")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.FCLLCLList,
      "option-value": "fcllclVal",
      "option-text": "fcllclText",
      "placeholder": "Select FCL / LCL"
    },
    on: {
      "input": _vm.getFreightEnquiryPriceingList
    },
    model: {
      value: (_vm.Filter.fclFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "fclFilter", $$v)
      },
      expression: "Filter.fclFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Enq. No Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Enq. No Filter",
      "id": "enqNoFilter",
      "name": "enqNoFilter",
      "autocomplete": "off"
    },
    on: {
      "input": _vm.getFreightEnquiryPriceingList
    },
    model: {
      value: (_vm.Filter.enqNoFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "enqNoFilter", $$v)
      },
      expression: "Filter.enqNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Created/Updated By")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "addedUserFilter",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Created User"
    },
    on: {
      "input": _vm.getFreightEnquiryPriceingList
    },
    model: {
      value: (_vm.Filter.userFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "userFilter", $$v)
      },
      expression: "Filter.userFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('label', [_vm._v("Common Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Common Filter",
      "id": "CommonFilter",
      "name": "CommonFilter",
      "autocomplete": "off"
    },
    on: {
      "input": _vm.getFreightEnquiryPriceingList
    },
    model: {
      value: (_vm.Filter.commonFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "commonFilter", $$v)
      },
      expression: "Filter.commonFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "ml-1 pull-right",
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('h5', [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.FrtEnqList.length) + " Entries")]) : _vm._e()])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [(_vm.FrtEnqList.length > 0) ? _c('b-button', {
    staticClass: "pull-right mb-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('checkJobPendency', 'Export As Excel')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.ExcelBtnName) + "\n            "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "2"
    }
  }, [_c('b-button', {
    attrs: {
      "size": "sm"
    },
    on: {
      "click": _vm.addRow
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle ml-1"
  })])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('div', [_c('b-button', {
    attrs: {
      "disabled": _vm.currentPage <= 1,
      "size": "sm"
    },
    on: {
      "click": _vm.prevPage
    }
  }, [_vm._v("Prev")]), _vm._v(" "), _vm._l((_vm.pageCount), function(page) {
    return _c('b-button', {
      key: page,
      class: 'ml-1 mr-1' + (page === _vm.currentPage ? ' active-page' : ''),
      attrs: {
        "disabled": page === _vm.currentPage
      },
      on: {
        "click": function($event) {
          _vm.goToPage(page)
        }
      }
    }, [_vm._v("\n              " + _vm._s(page) + "\n            ")])
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "disabled": _vm.currentPage >= _vm.pageCount,
      "size": "sm"
    },
    on: {
      "click": _vm.nextPage
    }
  }, [_vm._v("Next")]), _vm._v("\n            Page " + _vm._s(_vm.currentPage) + " of " + _vm._s(_vm.pageCount) + "\n          ")], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 row table-wrapper-scroll-x my-custom-scrollbar"
  }, [_c('table', {
    staticClass: "table table-bordered table-background position-relative"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("SN.")]), _vm._v(" "), _c('th', [_vm._v("Transport Type")]), _vm._v(" "), _c('th', [_vm._v("DATE")]), _vm._v(" "), _c('th', [_vm._v("INQUIRY NO.")]), _vm._v(" "), _c('th', [_vm._v("Branch")]), _vm._v(" "), _c('th', [_vm._v("SALES PERSON")]), _vm._v(" "), _c('th', [_vm._v("Shipping Line")]), _vm._v(" "), _c('th', [_vm._v("CLIENT")]), _vm._v(" "), _c('th', [_vm._v("INCOTERM")]), _vm._v(" "), _c('th', [_vm._v("POR")]), _vm._v(" "), _c('th', [_vm._v("POL")]), _vm._v(" "), _c('th', [_vm._v("DESTINATION")]), _vm._v(" "), _c('th', [_vm._v("FCL/LCL")]), _vm._v(" "), _c('th', [_vm._v("CARGO WEIGHT")]), _vm._v(" "), _c('th', [_vm._v("EQUIPMENT")]), _vm._v(" "), _c('th', [_vm._v("PDA")]), _vm._v(" "), _c('th', [_vm._v("PRICING REP.")]), _vm._v(" "), _c('th', [_vm._v("STATUS")]), _vm._v(" "), _c('th', [_vm._v("REMARKS")]), _vm._v(" "), _c('th', [_vm._v("Tentative Sail Date")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.paginatedRows), function(row, index) {
    return _c('tr', {
      key: row.id
    }, [_c('td', [_c('span', [_vm._v(_vm._s(index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(row.frt_enq_transport_type) + "\n                "), _c('model-list-select', {
      style: ({
        width: '200px'
      }),
      attrs: {
        "isDisabled": row.frt_enq_id > 0 ? true : false,
        "list": _vm.TransportTypeList,
        "id": "frt_enq_transport_type",
        "option-value": "StatusVal",
        "option-text": "StatusText",
        "placeholder": "Select Transport Type"
      },
      model: {
        value: (row.frt_enq_transport_type),
        callback: function($$v) {
          _vm.$set(row, "frt_enq_transport_type", $$v)
        },
        expression: "row.frt_enq_transport_type"
      }
    }), _vm._v(" "), (row.frt_enq_transport_type_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(row.frt_enq_transport_type_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "input-container"
    }, [_c('date-picker', {
      style: ({
        width: '200px'
      }),
      attrs: {
        "disabled": true,
        "format": _vm.selectDateFormat,
        "lang": "en",
        "name": "frt_enq_date",
        "id": "frt_enq_date",
        "not-before": _vm.calculateMinDate()
      },
      model: {
        value: (row.frt_enq_date),
        callback: function($$v) {
          _vm.$set(row, "frt_enq_date", $$v)
        },
        expression: "row.frt_enq_date"
      }
    }), _vm._v(" "), (row.frt_enq_date_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(row.frt_enq_date_err))]) : _vm._e()], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "input-container"
    }, [_c('b-form-input', {
      style: ({
        width: '200px'
      }),
      attrs: {
        "disabled": true,
        "formatter": _vm.capitalizeAll,
        "type": "text",
        "placeholder": "Enter Enquiry No "
      },
      model: {
        value: (row.frt_enq_no),
        callback: function($$v) {
          _vm.$set(row, "frt_enq_no", $$v)
        },
        expression: "row.frt_enq_no"
      }
    }), _vm._v(" "), (row.frt_enq_no_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(row.frt_enq_no_err))]) : _vm._e()], 1)]), _vm._v(" "), _c('td', [_c('model-list-select', {
      style: ({
        width: '200px'
      }),
      attrs: {
        "isDisabled": row.frt_enq_id > 0 ? true : false,
        "list": _vm.$store.getters['common/getAllBranchList'],
        "id": "fk_branch_id",
        "option-value": "pickupId",
        "option-text": "pickupLocation",
        "placeholder": "Select Branch Name"
      },
      model: {
        value: (row.fk_branch_id),
        callback: function($$v) {
          _vm.$set(row, "fk_branch_id", $$v)
        },
        expression: "row.fk_branch_id"
      }
    }), _vm._v(" "), (row.fk_branch_id_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(row.fk_branch_id_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('model-list-select', {
      style: ({
        width: '200px'
      }),
      attrs: {
        "isDisabled": row.frt_enq_id > 0 ? true : false,
        "list": _vm.$store.getters['common/getAllUserList'],
        "id": "addedUserFilter",
        "option-value": "userId",
        "option-text": "employeeName",
        "placeholder": "Select Sales Person"
      },
      model: {
        value: (row.fk_sales_person_id),
        callback: function($$v) {
          _vm.$set(row, "fk_sales_person_id", $$v)
        },
        expression: "row.fk_sales_person_id"
      }
    }), _vm._v(" "), (row.fk_sales_person_id_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(row.fk_sales_person_id_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('model-list-select', {
      style: ({
        width: '200px'
      }),
      attrs: {
        "isDisabled": row.frt_enq_id > 0 ? true : false,
        "list": _vm.$store.getters['common/getAllShippingLineList'],
        "option-value": "shippingId",
        "option-text": "shippingLine",
        "placeholder": "Select Shipping Line"
      },
      model: {
        value: (row.fk_sline_id),
        callback: function($$v) {
          _vm.$set(row, "fk_sline_id", $$v)
        },
        expression: "row.fk_sline_id"
      }
    }), _vm._v(" "), (row.fk_sline_id_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(row.fk_sline_id_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b-form-radio-group', {
      staticClass: "mb-3",
      attrs: {
        "options": _vm.clientTypeList,
        "value-field": "cVal",
        "text-field": "cText"
      },
      model: {
        value: (row.client_type),
        callback: function($$v) {
          _vm.$set(row, "client_type", $$v)
        },
        expression: "row.client_type"
      }
    }), _vm._v(" "), (row.client_type === 'Normal') ? _c('model-list-select', {
      style: ({
        width: '200px'
      }),
      attrs: {
        "isDisabled": row.frt_enq_id > 0 ? true : false,
        "list": _vm.$store.getters['common/getAllClientList'],
        "id": "clientNamenew",
        "option-value": "clientId",
        "option-text": "clientName",
        "placeholder": "Select Client Name"
      },
      model: {
        value: (row.fk_client_id),
        callback: function($$v) {
          _vm.$set(row, "fk_client_id", $$v)
        },
        expression: "row.fk_client_id"
      }
    }) : _vm._e(), _vm._v(" "), (row.fk_client_id_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(row.fk_client_id_err))]) : _vm._e(), _vm._v(" "), (row.fk_client_id_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(row.fk_client_id_err))]) : _vm._e(), _vm._v(" "), (row.client_type === 'General') ? _c('b-form-input', {
      style: ({
        width: '200px'
      }),
      attrs: {
        "type": "text"
      },
      model: {
        value: (row.frt_enq_general_client),
        callback: function($$v) {
          _vm.$set(row, "frt_enq_general_client", $$v)
        },
        expression: "row.frt_enq_general_client"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('model-list-select', {
      style: ({
        width: '200px'
      }),
      attrs: {
        "isDisabled": row.frt_enq_id > 0 ? true : false,
        "list": _vm.deliveryTermsName,
        "id": "frt_enq_incoterm",
        "option-value": "deliveryTermsVal",
        "option-text": "deliveryTermsText",
        "placeholder": "Select Incoterm"
      },
      model: {
        value: (row.frt_enq_incoterm),
        callback: function($$v) {
          _vm.$set(row, "frt_enq_incoterm", $$v)
        },
        expression: "row.frt_enq_incoterm"
      }
    }), _vm._v(" "), (row.frt_enq_incoterm_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(row.frt_enq_incoterm_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('multi-select', {
      style: ({
        width: '200px'
      }),
      attrs: {
        "isDisabled": row.frt_enq_id > 0 ? true : false,
        "options": row.frt_enq_transport_type == 'EXPORT' ?
          _vm.$store.getters[
            'enqPriceEngineDropdown/getAllEnqPriceEnginePORDDList'
          ] :
          row.frt_enq_transport_type == 'IMPORT' ?
          _vm.$store.getters[
            'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPORDDList'
          ] :
          row.frt_enq_transport_type == 'CRC' ?
          _vm.$store.getters[
            'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
          ] :
          _vm.$store.getters[
            'enqPriceEngineDropdown/getAllEnqPriceEnginePORDDList'
          ],
        "selected-options": row.fk_por_id_items,
        "placeholder": "Select POL",
        "multiple": true
      },
      on: {
        "select": function($event) {
          _vm.SelectPOR(row, index, $event)
        }
      },
      model: {
        value: (row.fk_por_id),
        callback: function($$v) {
          _vm.$set(row, "fk_por_id", $$v)
        },
        expression: "row.fk_por_id"
      }
    }), _vm._v(" "), (row.fk_por_id_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(row.fk_por_id_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('multi-select', {
      style: ({
        width: '200px'
      }),
      attrs: {
        "isDisabled": row.frt_enq_id > 0 ? true : false,
        "options": row.frt_enq_transport_type == 'EXPORT' ?
          _vm.$store.getters[
            'enqPriceEngineDropdown/getAllEnqPriceEnginePOLDDList'
          ] :
          row.frt_enq_transport_type == 'IMPORT' ?
          _vm.$store.getters[
            'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPOLDDList'
          ] :
          row.frt_enq_transport_type == 'CRC' ?
          _vm.$store.getters[
            'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
          ] :
          _vm.$store.getters[
            'enqPriceEngineDropdown/getAllEnqPriceEnginePOLDDList'
          ],
        "selected-options": row.fk_pol_id_items,
        "placeholder": "Select POL",
        "multiple": true
      },
      on: {
        "select": function($event) {
          _vm.SelectPOL(row, index, $event)
        }
      },
      model: {
        value: (row.fk_pol_id),
        callback: function($$v) {
          _vm.$set(row, "fk_pol_id", $$v)
        },
        expression: "row.fk_pol_id"
      }
    }), (row.fk_por_id_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(row.fk_por_id_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('multi-select', {
      style: ({
        width: '200px'
      }),
      attrs: {
        "isDisabled": row.frt_enq_id > 0 ? true : false,
        "options": row.frt_enq_transport_type == 'EXPORT' ?
          _vm.$store.getters[
            'enqPriceEngineDropdown/getAllEnqPriceEngineFPODDDList'
          ] :
          row.frt_enq_transport_type == 'IMPORT' ?
          _vm.$store.getters[
            'enqPriceEngineDropdown/getAllEnqPriceEngineIMPFPODDDList'
          ] :
          row.frt_enq_transport_type == 'CRC' ?
          _vm.$store.getters[
            'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
          ] :
          _vm.$store.getters[
            'enqPriceEngineDropdown/getAllEnqPriceEngineFPODDDList'
          ],
        "selected-options": row.fk_fpod_id_items,
        "placeholder": "Select FPOD",
        "multiple": true
      },
      on: {
        "select": function($event) {
          _vm.SelectFPOD(row, index, $event)
        }
      },
      model: {
        value: (row.fk_fpod_id),
        callback: function($$v) {
          _vm.$set(row, "fk_fpod_id", $$v)
        },
        expression: "row.fk_fpod_id"
      }
    }), _vm._v(" "), (row.fk_fpod_id_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(row.fk_fpod_id_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('model-list-select', {
      style: ({
        width: '200px'
      }),
      attrs: {
        "isDisabled": row.frt_enq_id > 0 ? true : false,
        "list": _vm.FCLLCLList,
        "id": "frt_enq_incoterm",
        "option-value": "fcllclVal",
        "option-text": "fcllclText",
        "placeholder": "Select FCL/LCL/AIR"
      },
      model: {
        value: (row.frt_enq_fcl_lcl),
        callback: function($$v) {
          _vm.$set(row, "frt_enq_fcl_lcl", $$v)
        },
        expression: "row.frt_enq_fcl_lcl"
      }
    }), _vm._v(" "), (row.frt_enq_fcl_lcl_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(row.frt_enq_fcl_lcl_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      style: ({
        width: '200px'
      }),
      attrs: {
        "disabled": row.frt_enq_id > 0 ? true : false,
        "formatter": _vm.capitalizeAll,
        "type": "number",
        "placeholder": "Enter Cargo Weight "
      },
      model: {
        value: (row.frt_enq_cargo_weight),
        callback: function($$v) {
          _vm.$set(row, "frt_enq_cargo_weight", $$v)
        },
        expression: "row.frt_enq_cargo_weight"
      }
    }), _vm._v(" "), (row.frt_enq_cargo_weight_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(row.frt_enq_cargo_weight_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('multi-select', {
      style: ({
        width: '200px'
      }),
      attrs: {
        "isDisabled": row.frt_enq_id > 0 ? true : false,
        "options": _vm.$store.getters['common/getAllContainerTypeList'],
        "selected-options": row.frt_enq_equipment_items,
        "placeholder": "Select Equipment",
        "multiple": true
      },
      on: {
        "select": function($event) {
          _vm.SelectEquipment(row, index, $event)
        }
      },
      model: {
        value: (row.frt_enq_equipment),
        callback: function($$v) {
          _vm.$set(row, "frt_enq_equipment", $$v)
        },
        expression: "row.frt_enq_equipment"
      }
    }), _vm._v(" "), (row.frt_enq_id <= 188) ? _c('span', [_vm._v(_vm._s(row.frt_enq_equipment))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      style: ({
        width: '200px'
      }),
      attrs: {
        "disabled": row.frt_enq_id > 0 ? true : false,
        "formatter": _vm.capitalizeAll,
        "type": "text",
        "placeholder": "Enter PDA"
      },
      model: {
        value: (row.frt_enq_pda),
        callback: function($$v) {
          _vm.$set(row, "frt_enq_pda", $$v)
        },
        expression: "row.frt_enq_pda"
      }
    }), _vm._v(" "), (row.frt_enq_pda_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(row.frt_enq_pda_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('model-list-select', {
      style: ({
        width: '200px'
      }),
      attrs: {
        "isDisabled": row.frt_enq_id > 0 ? true : false,
        "list": _vm.$store.getters['common/getAllUserList'],
        "id": "addedUserFilter",
        "option-value": "userId",
        "option-text": "employeeName",
        "placeholder": "Select Priceing Rep."
      },
      model: {
        value: (row.frt_enq_priceing_rep),
        callback: function($$v) {
          _vm.$set(row, "frt_enq_priceing_rep", $$v)
        },
        expression: "row.frt_enq_priceing_rep"
      }
    }), (row.frt_enq_priceing_rep_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(row.frt_enq_priceing_rep_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('model-list-select', {
      style: ({
        width: '200px'
      }),
      attrs: {
        "list": _vm.StatusList,
        "id": "frt_enq_status",
        "option-value": "StatusVal",
        "option-text": "StatusText",
        "placeholder": "Select Status"
      },
      model: {
        value: (row.frt_enq_status),
        callback: function($$v) {
          _vm.$set(row, "frt_enq_status", $$v)
        },
        expression: "row.frt_enq_status"
      }
    }), _vm._v(" "), (row.frt_enq_id > 0 && row.frt_enq_status == 'QUOTED') ? _c('b-button', {
      staticClass: "ml-1 mt-1",
      staticStyle: {
        "font-size": "0.675rem"
      },
      attrs: {
        "size": "sm",
        "variant": "outline-info"
      },
      on: {
        "click": function($event) {
          _vm.goToBookingREquest(row, 1)
        }
      }
    }, [_vm._v("Booking Request")]) : _vm._e(), _vm._v(" "), (row.frt_enq_status_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(row.frt_enq_status_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b-textarea', {
      key: index,
      style: ({
        width: '200px'
      }),
      attrs: {
        "formatter": _vm.capitalizeAll,
        "rows": "3",
        "type": "text",
        "placeholder": "Enter Remark"
      },
      model: {
        value: (row.frt_enq_remarks),
        callback: function($$v) {
          _vm.$set(row, "frt_enq_remarks", $$v)
        },
        expression: "row.frt_enq_remarks"
      }
    }), _vm._v(" "), (row.frt_enq_remarks_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(row.frt_enq_remarks_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "input-container"
    }, [_c('date-picker', {
      style: ({
        width: '200px'
      }),
      attrs: {
        "format": _vm.selectDateFormat,
        "lang": "en",
        "name": "frt_enq_tentative_sale_date",
        "id": "frt_enq_tentative_sale_date",
        "placeholder": "Enter Tentative Sail Date",
        "not-before": _vm.calculateMinDate()
      },
      model: {
        value: (row.frt_enq_tentative_sale_date),
        callback: function($$v) {
          _vm.$set(row, "frt_enq_tentative_sale_date", $$v)
        },
        expression: "row.frt_enq_tentative_sale_date"
      }
    }), _vm._v(" "), (row.frt_enq_tentative_sale_date_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(row.frt_enq_tentative_sale_date_err))]) : _vm._e()], 1)]), _vm._v(" "), _c('td', [_c('span', {
      style: ({
        display: 'none'
      })
    }, [_vm._v(_vm._s(index))]), _vm._v(" "), (row.frt_enq_id <= 188) ? _c('EnqCloseStatus', {
      attrs: {
        "PMC_title": 'Update Enquiry ' + row.frt_enq_no,
        "PMC_ENQID": row.frt_enq_id,
        "PMC_ENQNO": row.frt_enq_no,
        "PMC_ENQDATE": row.frt_enq_date,
        "PMC_ENQREMARK": row.frt_enq_remarks,
        "PMC_ENQSTATUS": row.frt_enq_status,
        "PMC_ENQTENTATIVESOB": row.frt_enq_tentative_sale_date
      }
    }) : _vm._e(), _vm._v(" "), _c('b-button', {
      attrs: {
        "variant": "primary",
        "id": "saveEnquiry"
      },
      on: {
        "click": function($event) {
          _vm.saveEnquiry(row, index, _vm.FrtEnqList[index])
        }
      }
    }, [_vm._v(_vm._s(row.frt_enq_id && row.frt_enq_id > 0 ? "Update" : "Save"))]), _vm._v(" "), (row.createdBy) ? _c('span', [_vm._v("Created By : " + _vm._s(row.createdBy))]) : _vm._e(), _c('br'), _vm._v(" "), (row.updatedBy) ? _c('span', [_vm._v("Updated By : " + _vm._s(row.updatedBy))]) : _vm._e(), _c('br'), _vm._v(" "), (!row.frt_enq_id) ? _c('b-button', {
      staticClass: "btn btn-sm btn-danger",
      on: {
        "click": function($event) {
          _vm.removeRow(index)
        }
      }
    }, [_vm._v("Remove")]) : _vm._e()], 1)])
  }))]), _vm._v(" "), _c('div', [_c('b-button', {
    attrs: {
      "disabled": _vm.currentPage <= 1,
      "size": "sm"
    },
    on: {
      "click": _vm.prevPage
    }
  }, [_vm._v("Prev")]), _vm._v(" "), _vm._l((_vm.pageCount), function(page) {
    return _c('b-button', {
      key: page,
      class: 'ml-1 mr-1' + (page === _vm.currentPage ? ' active-page' : ''),
      attrs: {
        "disabled": page === _vm.currentPage
      },
      on: {
        "click": function($event) {
          _vm.goToPage(page)
        }
      }
    }, [_vm._v("\n            " + _vm._s(page) + "\n          ")])
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "disabled": _vm.currentPage >= _vm.pageCount,
      "size": "sm"
    },
    on: {
      "click": _vm.nextPage
    }
  }, [_vm._v("Next")]), _vm._v("\n          Page " + _vm._s(_vm.currentPage) + " of " + _vm._s(_vm.pageCount) + "\n        ")], 2)])], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ff4a72d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/Pricing/freightEnquiryNew.vue
// module id = 2552
// module chunks = 0